import { grey } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  divider: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    padding: theme.spacing(0.625, 1),
    gap: theme.spacing(1.25),
    margin: theme.spacing(1, 0),
    color: grey[500],
    fontSize: 12,
    lineHeight: "18px",
    "&::before, &::after": {
      content: '""',
      flex: 1,
      height: 1,
      backgroundColor: grey[300],
    },
  },
  button: {
    width: "100%",
    height: 44,
    textTransform: "none",
    fontWeight: 500,
    color: theme.palette.common.black,
    backgroundColor: theme.palette.common.white,
    borderColor: grey[400],
    "&:hover": {
      backgroundColor: grey[50],
    },
  },
  label: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(1.5),
    width: "100%",
  },
  // Rendered on mount, so the hint is readable without hovering or focusing.
  lastLoginCaption: {
    display: "block",
    marginTop: theme.spacing(2),
    color: grey[500],
    fontSize: 12,
    lineHeight: "18px",
    textAlign: "center",
  },
}));

export default useStyles;
